export function handleScroll() {
    let button = document.getElementsByClassName("up-button")[0];
    button.classList[window.scrollY >= 800 ? "add" : "remove"]("up-button--show");
};
